// as-cetra-vet-ui/src/components/authenticated/handout/customise-mode/ConfirmRemoveDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import PinkGradientButton from '../../../UIControls/PinkGradientButton';

const ConfirmRemoveDialog = ({ open, onClose, onConfirm, title, message }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    p: { xs: 2, sm: 4 },
                    minWidth: { xs: 'auto', sm: '500px' },
                    maxWidth: '711px',
                    borderRadius: 4,
                    width: { xs: 'calc(100% - 32px)', sm: 'auto' },
                    m: { xs: 2, sm: 4 },
                },
            }}
        >
            <DialogTitle
                variant="h4"
                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 0, fontWeight: 600 }}
            >
                {title}
            </DialogTitle>
            <DialogContent sx={{ p: 0, mt: 3, mb: 4 }}>
                <Typography variant="body1" sx={{ color: '#616063' }}>{message}</Typography>
            </DialogContent>
            <DialogActions sx={{ p: 0, mt: { xs: 0, sm: 3 }, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center' }}>
                <PinkGradientButton
                    onClick={onConfirm}
                    sx={{ my: { xs: 1, sm: 1.5 }, mr: { sm: 2 }, background: '#FF669B', backgroundImage: 'none', '&:hover': { background: '#FF85B0', backgroundImage: 'none' } }}
                >
                    Yes
                </PinkGradientButton>
                <Button
                    onClick={onClose}
                    sx={{ color: '#0b0c26', textDecoration: 'underline', textTransform: 'none', fontWeight: 600, height: { xs: 'auto', sm: 48 }, mt: { xs: 1, sm: 0 } }}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmRemoveDialog;
